"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const pino_1 = __importDefault(require("pino"));
const react_1 = require("react");
const react_router_1 = require("react-router");
const appConstants_1 = require("../../../../constants/appConstants");
const strings_1 = require("../../../../constants/strings");
const uiConstants_1 = require("../../../../constants/uiConstants");
const companyQuery_1 = require("../../../../queries/companyQuery");
const teamQuery_1 = require("../../../../queries/teamQuery");
const userQuery_1 = require("../../../../queries/userQuery");
const service_1 = require("../../../../react-services/service");
const pageLoader_1 = __importDefault(require("../../../../router/loaders/pageLoader"));
const zustandStore_1 = require("../../../../zustandStore");
const simpleButton_1 = __importDefault(require("../../../atoms/button/simpleButton"));
const footer_1 = __importDefault(require("../../../organisms/footer"));
const useTeamState_1 = require("./hooks/useTeamState");
const teamTable_1 = __importDefault(require("./teamTable"));
const logger = (0, pino_1.default)();
const lexico = new lexico_1.default();
const TeamAside = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../../../organisms/teamAside'))));
const CreateTeamModal = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../../../organisms/createTeamModal'))));
function resetTeamState({ setTeamRequestLimit, setTeamId, setTeamName, setTeam }) {
    setTeamId('');
    setTeamName('');
    setTeamRequestLimit('');
    setTeam(null);
}
const saveAndContinue_id = 'saveAndContinue';
function getActionButtonLabel(isTeamSettingsModalOpen, step, isAmexCardProvider) {
    if (isAmexCardProvider) {
        if (isTeamSettingsModalOpen && step === 2) {
            return strings_1.companySettingsTeamsStrings.SAVE;
        }
    }
    else {
        if (isTeamSettingsModalOpen && step === 1) {
            return strings_1.companySettingsTeamsStrings.SAVE;
        }
    }
    return isTeamSettingsModalOpen
        ? strings_1.companySettingsTeamsStrings.SAVE_AND_CONTINUE
        : strings_1.companySettingsTeamsStrings.CREATE_NEW_TEAM;
}
function getActionButtonDataTestId(isTeamSettingsModalOpen, step) {
    if (isTeamSettingsModalOpen && step === 2) {
        return 'save-btn';
    }
    return isTeamSettingsModalOpen ? 'saveAndContinue-btn' : 'createNewTeam-btn';
}
function setCurrentFooterButtons({ isTeamSettingsModalOpen, setFooterButtons, createTeamName, setTeamId, teamName, setIsTeamSubmitting, openCreateTeamModal, setIsTeamModalOpen, step, setStep, users, currentTeamName, setCurrentTeamNameOnSubmit, setIsAddPeopleAsideOpen, isTeamNameError, saveUserSetting, isTeamRequestLimitError, areAllCardFeaturesDisabled, isCardSourcesCollectionNonEmpty, company, setPageLoading, isAmexCardProvider, }) {
    const isWhiteListDomainsEmpty = company.properties.whiteListedDomains.length === 0;
    const isButtonDisabled = isTeamSettingsModalOpen
        ? !teamName ||
            isTeamNameError ||
            isTeamRequestLimitError ||
            areAllCardFeaturesDisabled ||
            !isCardSourcesCollectionNonEmpty
        : false;
    const btns = [];
    if (isAmexCardProvider && (step === 1 || step === 2)) {
        btns.push({
            id: 'back',
            dataTestId: 'back-btn',
            label: strings_1.companySettingsTeamsStrings.BACK_BUTTON,
            color: uiConstants_1.UI_BUTTON_SECONDARY,
            onclick: () => {
                setStep(step - 1);
                setPageLoading(true);
            },
        });
    }
    if (users && users?.length > 0 && step === 1) {
        btns.push({
            id: 'invitePeople',
            dataTestId: 'invite-people-btn',
            label: strings_1.companySettingsTeamsStrings.INVITE_PEOPLE_BUTTON,
            disabled: company.features.ENABLE_DOMAIN_WHITELISTING ? isWhiteListDomainsEmpty : false,
            color: uiConstants_1.UI_BUTTON_SECONDARY,
            onclick: () => {
                setIsAddPeopleAsideOpen(true);
            },
        });
    }
    setFooterButtons([
        ...btns,
        {
            id: saveAndContinue_id,
            dataTestId: getActionButtonDataTestId(isTeamSettingsModalOpen, step),
            disabled: isButtonDisabled,
            label: getActionButtonLabel(isTeamSettingsModalOpen, step, isAmexCardProvider),
            color: uiConstants_1.UI_BUTTON_PRIMARY,
            onclick: () => {
                const setCountToCloseModal = isAmexCardProvider ? 2 : 1;
                setPageLoading(true);
                if (isTeamSettingsModalOpen && step === setCountToCloseModal) {
                    setIsTeamModalOpen(false);
                    setPageLoading(false);
                    setStep(0);
                    return;
                }
                if (isTeamSettingsModalOpen && step === 0) {
                    if (currentTeamName === teamName) {
                        setStep(1);
                        return;
                    }
                    createTeamName.mutate({ teamName }, {
                        onSuccess: (data) => {
                            setIsTeamSubmitting(true);
                            // we save the set currentTeamName, so if we save it and go back, we don't save it again
                            setCurrentTeamNameOnSubmit(teamName);
                            saveUserSetting.mutate({ selectedTeamID: data.teamId });
                            setTeamId(data.teamId);
                        },
                    });
                    return;
                }
                if (!isTeamSettingsModalOpen) {
                    openCreateTeamModal();
                    return;
                }
                setStep(step + 1);
            },
        },
    ]);
}
const CompanySettingsTeamsTemplate = () => {
    const [asideTitle, setAsideTitle] = (0, react_1.useState)('');
    const [openConfirm, setOpenConfirm] = (0, react_1.useState)(false);
    const saveTeamProperty = (0, teamQuery_1.useSaveTeamPropertyQuery)();
    const setCurrentTeamById = (0, teamQuery_1.useSetCurrentTeamByIdQuery)();
    const activateTeam = (0, teamQuery_1.useActivateTeamQuery)();
    const deactivateTeam = (0, teamQuery_1.useDeActivateTeamQuery)();
    const createTeamName = (0, teamQuery_1.useCreateTeamQuery)();
    const navigate = (0, react_router_1.useNavigate)();
    const { setPageLoading, footer } = (0, zustandStore_1.useZustand)();
    const state = (0, useTeamState_1.useTeamState)();
    const saveUserSetting = (0, userQuery_1.useSaveUserSettingQuery)();
    const theme = (0, material_1.useTheme)();
    const { refetch: refetchGetTeamProperty } = (0, teamQuery_1.useGetTeamPropertyQuery)(state.team?.id || '');
    const { data: userData } = (0, teamQuery_1.useGetTeamUsersQuery)({ teamId: state.teamId });
    const { data: currentUser } = (0, react_query_1.useQuery)(userQuery_1.userQuery);
    const { data: companyPropertiesData } = (0, react_query_1.useQuery)((0, companyQuery_1.companyPropertiesQuery)(currentUser?.companyAccountId, {
        cardprovider: 'tsgo-cardprovider',
    }));
    const cardProvider = companyPropertiesData?.cardprovider;
    const isAmexCardProvider = cardProvider === 'AMEX';
    const isCardSourcesCollectionNonEmpty = state.cardOptions.length > 0;
    const users = (0, react_1.useMemo)(() => {
        return userData?.users || [];
    }, [userData?.users]);
    (0, react_1.useEffect)(() => {
        setPageLoading(false);
    }, [footer.buttons, setPageLoading]);
    (0, react_1.useEffect)(() => {
        if (state.team && state.team.id) {
            void refetchGetTeamProperty();
        }
    }, [refetchGetTeamProperty, state.team]);
    const openCreateTeamModal = (0, react_1.useCallback)(() => {
        resetTeamState({
            setTeamRequestLimit: state.setTeamRequestLimit,
            setTeamId: state.setTeamId,
            setTeamName: state.setTeamName,
            setTeam: state.setTeam,
        });
        state.setIsTeamModalOpen(true);
    }, [state]);
    (0, react_1.useEffect)(() => {
        setCurrentFooterButtons({
            isTeamSettingsModalOpen: state.isTeamSettingsModalOpen,
            setFooterButtons: state.setFooterButtons,
            createTeamName,
            setTeamId: state.setTeamId,
            teamName: state.teamName,
            setIsTeamSubmitting: state.setIsTeamSubmitting,
            openCreateTeamModal,
            setIsTeamModalOpen: state.setIsTeamModalOpen,
            step: state.step,
            setStep: state.setStep,
            users,
            setCurrentTeamNameOnSubmit: state.setCurrentTeamNameOnSubmit,
            currentTeamName: state.currentTeamName,
            isTeamNameError: state.isTeamNameError,
            saveUserSetting,
            isTeamRequestLimitError: state.isTeamRequestLimitError,
            areAllCardFeaturesDisabled: state.areAllCardFeaturesDisabled,
            isCardSourcesCollectionNonEmpty,
            company: state.company,
            setIsAddPeopleAsideOpen: state.setIsAddPeopleAsideOpen,
            setPageLoading: state.setPageLoading,
            isAmexCardProvider,
        });
    }, [
        state.isTeamSettingsModalOpen,
        state.step,
        state.teamId,
        state.teamName,
        users,
        state.isTeamRequestLimitError,
        state.areAllCardFeaturesDisabled,
        isCardSourcesCollectionNonEmpty,
        state.company,
    ]);
    const closeAside = () => {
        state.setIsTeamAsideOpen(false);
    };
    const onActionsButtonClicked = (0, react_1.useCallback)((name, value) => {
        state.setIsSaveBtnDisabled(true);
        state.setUserSelectedTeam(value?.id);
        state.setTeamId(value.id);
        state.setTeam(value);
        state.setIsTeamAsideOpen(true);
        setAsideTitle(name);
        saveUserSetting.mutate({ selectedTeamID: String(value?.id) || '' });
    }, [saveUserSetting, state]);
    const goToTeamSettings = (0, react_1.useCallback)(() => {
        if (state.team?.id === undefined) {
            logger.error(`goToTeamSettings setCurrentTeamById(${state.team?.id})`);
            return;
        }
        setCurrentTeamById.mutate(state.team.id, {
            onSuccess: () => {
                state.setHasChanges(false);
                state.setIsTeamAsideOpen(false);
                void navigate('/team/overview');
            },
            onError: () => {
                logger.error(`goToTeamSettings setCurrentTeamById(${state.team?.id})`);
            },
        });
    }, [state, setCurrentTeamById, navigate]);
    const toggleCardCreation = () => {
        saveTeamProperty.mutate({
            teamId: state.team?.id || '',
            propertyKey: appConstants_1.teamPropertiesConstant.pauseVirtualCardCreation,
            propertyValue: state.isCardCreationPaused === 'false' ? 'true' : 'false',
        }, {
            onSuccess: () => {
                state.setNotification([
                    {
                        type: strings_1.notificationStrings.SUCCESS,
                        message: state.isCardCreationPaused === 'false'
                            ? `Card creation paused for ${state.team?.name}`
                            : `Card creation unpaused for ${state.team?.name}`,
                    },
                ]);
                closeAside();
            },
            onError: error => {
                logger.error({ error });
                state.setNotification([
                    {
                        type: strings_1.notificationStrings.ERROR,
                        message: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                            ? strings_1.errorStrings.DEFAULT
                            : strings_1.companySettingsTeamsStrings.WARNING_MESSAGE,
                    },
                ]);
                closeAside();
            },
        });
    };
    const openConfirmAside = () => {
        setOpenConfirm(true);
    };
    const closeConfirmAside = () => {
        setOpenConfirm(false);
    };
    const activateTeamData = () => {
        activateTeam.mutate(state.team?.id);
        closeConfirmAside();
        closeAside();
    };
    const deactivateTeamData = () => {
        deactivateTeam.mutate(state.team?.id);
        closeConfirmAside();
        closeAside();
    };
    const closeCreateTeamModal = (isModalOpen = false) => {
        state.setStep(0);
        state.setTeamId('');
        state.setTeam({});
        state.setIsTeamModalOpen(false);
        if (!isModalOpen) {
            state.setTeamName('');
            state.setTeamRequestLimit('');
            void navigate('/settings/teams');
        }
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [state.isTeamSettingsModalOpen ? ((0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)(pageLoader_1.default, {}), children: (0, jsx_runtime_1.jsx)(CreateTeamModal, { closeCreateTeamModal: closeCreateTeamModal }) })) : ((0, jsx_runtime_1.jsxs)(material_1.Paper, { "ts-variant": "container", children: [(0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, sx: {
                            marginBottom: 2,
                        }, children: (0, jsx_runtime_1.jsx)(material_1.Grid, { size: 12, children: (0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "download-user-list-button", label: strings_1.companySettingsTeamsStrings.DOWNLOAD_USER_LIST, color: uiConstants_1.UI_BUTTON_SECONDARY, size: uiConstants_1.UI_BUTTON_MICRO, style: { float: 'right', fontSize: theme.typography.tsFontSize.small }, onClick: () => {
                                    void (0, service_1.downloadReport)({ reportType: 'users' }).then(report => {
                                        if (!report.data) {
                                            state.setNotification([
                                                {
                                                    type: strings_1.notificationStrings.WARNING,
                                                    message: lexico.tr('There is no data available for download'),
                                                },
                                            ]);
                                        }
                                    });
                                } }) }) }), (0, jsx_runtime_1.jsx)(teamTable_1.default, { tableId: "teamTable", onActionButtonClick: onActionsButtonClicked }), (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)("div", {}), children: (0, jsx_runtime_1.jsx)(TeamAside, { asideTitle: asideTitle, goToTeamSettings: goToTeamSettings, toggleCardCreation: toggleCardCreation, openConfirmAside: openConfirmAside, closeConfirmAside: closeConfirmAside, openConfirm: openConfirm, closeAside: closeAside, activateTeam: activateTeamData, deactivateTeam: deactivateTeamData, confirmAsideTitle: strings_1.companySettingsTeamsStrings.CONFIRM_ACTION_TITLE, confirmAsideContent: globalThis.cardProvider.IS_AMEX_PROVIDER_SETUP
                                ? strings_1.companySettingsTeamsStrings.NOTIFICATION_MESSAGE
                                : strings_1.companySettingsTeamsStrings.HSBC_NOTIFICATION_MESSAGE }) })] })), (0, jsx_runtime_1.jsx)(footer_1.default, {})] }));
};
exports.default = CompanySettingsTeamsTemplate;
